module.exports = __webpack_public_path__ + "img/other_oppo1.3f4a9eb5.jpg";